import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/user/dashboard", search, replace: true });
  },
});
